import React from 'react';
export function ProductPresentation() {
  return <section className="w-full bg-sand-100 py-24 md:py-32 px-6" data-id="element-114">
      <div className="max-w-3xl mx-auto text-center" data-id="element-115">
        <h2 className="font-serif text-3xl md:text-5xl text-charcoal-700 mb-12 leading-tight uppercase tracking-wide" data-id="element-116">
          Florecer es ese acompañamiento que muchas veces falta
        </h2>

        <div className="text-lg md:text-xl text-charcoal-400 font-light leading-relaxed mb-16 space-y-4" data-id="element-117">
          <p data-id="element-118">No es solo información.</p>
          <p data-id="element-119">
            Es una guía pensada para ayudarte a transitar esta etapa con más
            calma, claridad y seguridad.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-120">
          {['Sin términos difíciles', 'Sin juicios', 'Sin exigencias irreales'].map((tag, index) => <div key={index} className="px-6 py-3 bg-sage-300/30 border border-sage-300 rounded-full text-charcoal-500 text-sm tracking-wider uppercase" data-id="element-121">
              {tag}
            </div>)}
        </div>
      </div>
    </section>;
}